<template>
  <main id="landing">
      <sign-in />
      <button class="btn sml outline" @click="createRoom">{{ btnText }}</button>
  </main>
</template>

<script>
import SignIn from '../components/SignIn.vue'


export default {
    name: 'Landing',
    components: {
      SignIn
    },
    data(){
      return {
        btnText: 'Create Room'
      }
    },
    methods: {
      createRoom(){
        this.btnText = 'Creating room...'
        this.$store.dispatch('createRoom');
      }
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#landing {
  grid-column: auto / span 6;
  height: 100vh;
  width: 100vw;
  background: $blueGradient;
  @include center;

  .outline {
    position: fixed;
    top: 1rem;
    right: 1rem;
    transition: opacity .2s ease;
    z-index: 999;
    background: none;
    color: $white;

    &:hover {
      opacity: 1;
      background-color: $white;
      color: $darkGrey;
      cursor: pointer;
    } 
  }
}
</style>